import BaseAudioVisualizer from "./BaseAudioVisualizer";

class MediaStreamAudioVisualizer extends BaseAudioVisualizer {
  private mediaStreamSource: MediaStreamAudioSourceNode | null = null;
  private stream: MediaStream | null = null;

  protected async setupAudioSource(): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.stream = stream;
    this.mediaStreamSource = this.audioContext.createMediaStreamSource(stream);
    this.analyser = this.audioContext.createAnalyser();
    this.analyser.fftSize = 256;
    this.mediaStreamSource.connect(this.analyser);
  }

  protected cleanupAudioNodes(): void {
    if (this.mediaStreamSource) {
      this.mediaStreamSource.disconnect();
      this.mediaStreamSource = null;
    }
    if (this.analyser) {
      this.analyser.disconnect();
      this.analyser = null;
    }
    if (this.stream) {
      const tracks = this.stream.getAudioTracks();
      tracks.forEach((track) => track.stop());
      this.stream = null;
    }
  }

  public getMediaStream() {
    return this.stream;
  }
}

export default MediaStreamAudioVisualizer;
